module.exports = __webpack_public_path__ + "static/media/menu-travel.af8a4354.png";